module.exports = __webpack_public_path__ + "img/7.8b14a1c2.jpg";